import React from 'react';
import { motion } from 'framer-motion';
import { StackEndProps } from './types';
import styles from './StackEnd.module.css';

const StackEnd: React.FC<StackEndProps> = ({ 
  onClose, 
  emoji, 
  heading = "You're all caught up",
  description = "You've gone through today's insights. Check later for new insights.",
  buttonText = "Back to home"
}) => {
  const showEmoji = emoji !== undefined && emoji !== null;
  
  return (
    <motion.div 
      className={styles.stackEnd}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
    >
      <div className={styles.stackEndContent}>
        <div className={styles.iconContainer}>
          {showEmoji ? (
            <span className={styles.emoji}>{emoji}</span>
          ) : (
            <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.00002 16.17L4.83002 12L3.41002 13.41L9.00002 19L21 7.00001L19.59 5.59001L9.00002 16.17Z" fill="#1F9C1C"/>
            </svg>
          )}
        </div>
        <div className={styles.textContent}>
          <h2 className={styles.heading}>{heading}</h2>
          <p className={styles.description}>{description}</p>
        </div>
        <motion.button
          className={styles.resetButton}
          onClick={onClose}
          whileTap={{ scale: 0.95 }}
        >
          <span>{buttonText}</span>
        </motion.button>
      </div>
    </motion.div>
  );
};

export default StackEnd;